/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_dw_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`List restaurants and spin to decide where to eat.`)
};

const es_dw_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enumera restaurantes y gira para decidir dónde comer.`)
};

const de_dw_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Liste Restaurants auf und dreh das Rad, um zu entscheiden, wo es hingeht.`)
};

const nl_dw_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zet restaurants op de lijst en draai om te bepalen waar je gaat eten.`)
};

const fr_dw_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Listez des restaurants et faites tourner la roue pour décider où manger.`)
};

const it_dw_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Elenca dei ristoranti e gira per decidere dove mangiare.`)
};

const pt_br2_dw_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Liste restaurantes e gire para decidir onde comer.`)
};

const pt_dw_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Liste restaurantes e gire para decidir onde comer.`)
};

const ja_dw_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`レストランをリストアップして回し、どこで食事をするか決めましょう。`)
};

const zh_dw_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`列出餐厅名称，转动转盘决定去哪里吃饭。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const dw_ex1 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.dw_ex1(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("dw_ex1", locale)
	if (locale === "en") return en_dw_ex1(inputs)
	if (locale === "es") return es_dw_ex1(inputs)
	if (locale === "de") return de_dw_ex1(inputs)
	if (locale === "nl") return nl_dw_ex1(inputs)
	if (locale === "fr") return fr_dw_ex1(inputs)
	if (locale === "it") return it_dw_ex1(inputs)
	if (locale === "pt-BR") return pt_br2_dw_ex1(inputs)
	if (locale === "pt") return pt_dw_ex1(inputs)
	if (locale === "ja") return ja_dw_ex1(inputs)
	return zh_dw_ex1(inputs)
};